<template>
  <div>
    <PageLoader :storage="appLoading" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#FF6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start pa-5>
          <!-- Page Header -->
          <v-flex xs12>
            <v-layout wrap justify-space-between align-center>
              <v-flex xs6>
                <span class="heading">Ratings Operations</span>
              </v-flex>
            </v-layout>
          </v-flex>

          <!-- Table List -->
          <v-flex xs12 class="pt-5" v-if="ratingsList && ratingsList.length > 0">
            <v-card outlined>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left tableheading">Rescuer</th>
                      <th class="text-center tableheading">District</th>
                      <th class="text-center tableheading">Rating</th>
                      <th class="text-center tableheading">Rated At</th>
                      <th class="text-left tableheading">Rated By</th>
                      <th class="text-center tableheading">Action</th>
                    </tr>
                  </thead>
                  <tbody class="tablesubheading">
                    <tr v-for="(item, index) in ratingsList" :key="index">
                      <td class="text-left">
                        <div style="font-family: poppinssemibold; color: #333;">
                          {{ (item.rescuer && item.rescuer.name) || 'N/A' }}
                        </div>
                        <div style="font-size: 11px; color: grey;">
                          Code: {{ (item.rescuer && item.rescuer.rescuerCode) || 'N/A' }}
                        </div>
                      </td>
                      <td class="text-center">{{ (item.operation && item.operation.district) || '-' }}</td>
                      <td class="text-center">
                        <div class="d-flex align-center justify-center">
                          <v-rating
                            v-if="item.feedback && item.feedback.rating"
                            :value="item.feedback.rating"
                            color="amber"
                            dense
                            half-increments
                            readonly
                            size="16"
                          ></v-rating>
                          <span v-else>-</span>
                        </div>
                      </td>
                      <td class="text-center">{{ formatDate(item.feedback && item.feedback.ratingAt) }}</td>
                      <td class="text-left">
                        <div style="font-family: poppinssemibold; color: #333;" v-if="item.report && item.report.reportedBy">
                          {{ item.report.reportedBy.name || item.report.reportedBy.username || '-' }}
                        </div>
                        
                        <span v-else>-</span>
                      </td>
                      <td class="text-center">
                        <v-btn small color="#FF6907" text @click="openDetails(item)">
                          <v-icon left small>mdi-eye</v-icon> View Details
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Pagination -->
      <v-flex xs12 pb-4 v-if="ratingsList && ratingsList.length > 0">
        <v-layout wrap justify-center>
          <v-flex xs10>
            <v-pagination
              v-model="currentPage"
              :length="pageLength"
              :total-visible="7"
              circle
              color="#FF6907"
              small
            ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Empty State -->
      <v-flex xs12 v-else-if="!appLoading">
        <v-layout wrap justify-start pl-5 pt-5>
          <v-flex xs12 class="text-left">
            <span class="heading">No Ratings Found!</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <!-- Details Dialog (Modal) -->
    <v-dialog v-model="detailsDialog" max-width="700">
      <v-card v-if="selectedRating">
        <v-card-title class="heading d-flex justify-space-between align-center" style="background-color: #f6fff9; border-bottom: 1px solid #e0e0e0;">
          <span>Ratings & Feedback Details</span>
          <v-btn icon @click="detailsDialog = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pt-4" style="font-family: poppinsregular;">
          <v-layout wrap>
            
            <!-- SECTION 1: Rescuer Info -->
            <v-flex xs12 class="mb-3">
              <div class="subheading" style="font-family: poppinssemibold; color: #FF6907; border-bottom: 1px solid #FF6907; padding-bottom: 4px;">
                Rescuer Information
              </div>
            </v-flex>
            
            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Name</div>
              <div style="font-size: 14px; font-family: poppinssemibold;">{{ selectedRating.rescuer ? selectedRating.rescuer.name : '-' }}</div>
            </v-flex>
            
            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Rescuer Code / Username</div>
              <div style="font-size: 14px;">{{ selectedRating.rescuer ? selectedRating.rescuer.rescuerCode : '-' }} ({{ selectedRating.rescuer ? selectedRating.rescuer.username : '-' }})</div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Phone Number</div>
              <div style="font-size: 14px;">{{ selectedRating.rescuer ? selectedRating.rescuer.phone : '-' }}</div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">District</div>
              <div style="font-size: 14px;">{{ selectedRating.rescuer ? selectedRating.rescuer.district : '-' }}</div>
            </v-flex>

            <v-flex xs12 sm4 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Total Rescues</div>
              <div style="font-size: 14px; font-family: poppinssemibold;">{{ selectedRating.rescuer ? selectedRating.rescuer.noOfRescues : 0 }}</div>
            </v-flex>

            <v-flex xs12 sm4 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Average Rating</div>
              <div class="d-flex align-center mt-1">
                <v-rating
                  v-if="selectedRating.rescuer && selectedRating.rescuer.averageRating"
                  :value="selectedRating.rescuer.averageRating"
                  color="amber"
                  dense
                  half-increments
                  readonly
                  size="14"
                ></v-rating>
                <span class="ml-1" style="font-size: 14px; font-family: poppinssemibold;">
                  ({{ selectedRating.rescuer ? selectedRating.rescuer.averageRating : 0 }}/5)
                </span>
              </div>
            </v-flex>

            <v-flex xs12 sm4 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Rating Count</div>
              <div style="font-size: 14px;">{{ selectedRating.rescuer ? selectedRating.rescuer.ratingCount : 0 }} reviews</div>
            </v-flex>

            <!-- SECTION 2: Feedback Details -->
            <v-flex xs12 class="mt-4 mb-3">
              <div class="subheading" style="font-family: poppinssemibold; color: #FF6907; border-bottom: 1px solid #FF6907; padding-bottom: 4px;">
                Feedback & Review
              </div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Given Rating</div>
              <div class="d-flex align-center mt-1">
                <v-rating
                  v-if="selectedRating.feedback && selectedRating.feedback.rating"
                  :value="selectedRating.feedback.rating"
                  color="amber"
                  dense
                  half-increments
                  readonly
                  size="18"
                ></v-rating>
                <span class="ml-2" style="font-size: 16px; font-family: poppinssemibold;">
                  {{ selectedRating.feedback ? selectedRating.feedback.rating : '-' }} Stars
                </span>
              </div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Feedback Submitted At</div>
              <div style="font-size: 14px;">{{ formatDate(selectedRating.feedback ? selectedRating.feedback.ratingAt : null) }}</div>
            </v-flex>

            <v-flex xs12 px-2 mb-2>
              <div style="font-size: 12px; color: grey; margin-bottom: 4px;">Review Message</div>
              <div style="background-color: #fafafa; border: 1px solid #eee; border-radius: 4px; padding: 12px; font-size: 13.5px; line-height: 1.5; font-style: italic;">
                "{{ selectedRating.feedback ? selectedRating.feedback.review : 'No review message provided' }}"
              </div>
            </v-flex>

            <!-- SECTION 3: Operation Details -->
            <v-flex xs12 class="mt-4 mb-3">
              <div class="subheading" style="font-family: poppinssemibold; color: #FF6907; border-bottom: 1px solid #FF6907; padding-bottom: 4px;">
                Operation & Report Context
              </div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Operation Status</div>
              <div style="font-size: 14px; font-family: poppinssemibold; color: green;">{{ selectedRating.operation ? selectedRating.operation.status : '-' }}</div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Operation District</div>
              <div style="font-size: 14px;">{{ selectedRating.operation ? selectedRating.operation.district : '-' }}</div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2>
              <div style="font-size: 12px; color: grey;">Reported At</div>
              <div style="font-size: 14px;">{{ formatDate(selectedRating.operation ? selectedRating.operation.reportedAt : null) }}</div>
            </v-flex>

            <v-flex xs12 sm6 px-2 mb-2 v-if="selectedRating.report">
              <div style="font-size: 12px; color: grey;">Report Status / ID</div>
              <div style="font-size: 13px;">{{ selectedRating.report.status || '-' }} ({{ selectedRating.report._id }})</div>
            </v-flex>

            <!-- SECTION 4: Reporter Details -->
            <v-flex xs12 class="mt-4 mb-3" v-if="selectedRating.report && selectedRating.report.reportedBy">
              <div class="subheading" style="font-family: poppinssemibold; color: #FF6907; border-bottom: 1px solid #FF6907; padding-bottom: 4px;">
                Reporter Details
              </div>
            </v-flex>

            <v-flex xs12 sm4 px-2 mb-2 v-if="selectedRating.report && selectedRating.report.reportedBy">
              <div style="font-size: 12px; color: grey;">Reporter Name</div>
              <div style="font-size: 14px; font-family: poppinssemibold;">{{ selectedRating.report.reportedBy.name || '-' }}</div>
            </v-flex>

            <v-flex xs12 sm4 px-2 mb-2 v-if="selectedRating.report && selectedRating.report.reportedBy">
              <div style="font-size: 12px; color: grey;">Reporter Phone</div>
              <div style="font-size: 14px;">{{ selectedRating.report.reportedBy.phone || '-' }}</div>
            </v-flex>

            <v-flex xs12 sm4 px-2 mb-2 v-if="selectedRating.report && selectedRating.report.reportedBy">
              <div style="font-size: 12px; color: grey;">Reporter Username</div>
              <div style="font-size: 14px;">{{ selectedRating.report.reportedBy.username || '-' }}</div>
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn color="#FF6907" depressed dark @click="detailsDialog = false">
            <span style="color: #fff">Close</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      ratingsList: [],
      currentPage: 1,
      pageLength: 0,
      limit: 10,
      detailsDialog: false,
      selectedRating: null,
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    currentPage() {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/operation/ratings/list",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        params: {
          page: this.currentPage,
          limit: this.limit
        }
      })
      .then(response => {
        this.appLoading = false;
        if (response.data.status === true) {
          this.ratingsList = response.data.data;
          this.pageLength = response.data.pages || 1;
        } else {
          this.ratingsList = [];
          this.msg = response.data.msg;
          this.showSnackBar = true;
        }
      })
      .catch(err => {
        this.appLoading = false;
        this.ServerError = true;
        console.error("Error fetching ratings list:", err);
      });
    },
    openDetails(item) {
      this.selectedRating = item;
      this.detailsDialog = true;
    },
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });
    }
  }
};
</script>

<style>
.heading {
  font-family: poppinsregular;
  font-size: 20px;
  font-weight: 900;
}
.subheading {
  font-family: poppinsregular;
  font-size: 15px;
  font-weight: 500;
}
.tableheading {
  font-family: poppinsregular;
  font-size: 15px !important;
  color: black !important;
  text-transform: uppercase !important;
}
.tablesubheading {
  font-family: poppinsregular;
  font-size: 13px;
}
</style>
